import { Person } from "@/Common/Models/Person/Person";
import { IJApssInboxModel } from "../Models/JSONInterfaces/IJApssInboxModel";
import { ApssFilterType } from "../Models/UI/IAPSSInboxModel";

class PortfolioHelper {
    public static getDefaultApssModel(selectedEmployeeApss: Person, showPrerequisManquant: boolean, filterType: ApssFilterType): IJApssInboxModel {
        return {
            CurrentPage: 1,
            SelectedPageSizeOption: 50,
            PageSizeOptions: [50, 100, 150],
            SelectedPageNumber: 1,
            TableData: [],
            ColumnOrderingPopupOpen: false,
            ShowSettings: false,
            SelectedEmployee: selectedEmployeeApss,
            StatusFilter: [],
            ShowPrerequisManquant: showPrerequisManquant,
            GeneratedFileName: "",
            FilterType: filterType,
            ShowArchivedPurges: false,
            ConseilNumeriqueSelectedPageSizeOption: 50,
            ConseilNumeriqueCurrentPage: 1,
            ShowArchivedConseilNumerique: false
        };
    }

    public static getDocumoFaxResultText(resultCode?: string): string {
        switch (resultCode) {
            case "0":
                return cacheStore.GetString("DocumoResultCode0");
            case "1000":
                return cacheStore.GetString("DocumoResultCode1000");
            case "4000":
                return cacheStore.GetString("DocumoResultCode4000");
            case "5000":
                return cacheStore.GetString("DocumoResultCode5000");
            case "5100":
                return cacheStore.GetString("DocumoResultCode5100");
            case "5200":
                return cacheStore.GetString("DocumoResultCode5200");
            case "6000":
                return cacheStore.GetString("DocumoResultCode6000");
            case "6100":
                return cacheStore.GetString("DocumoResultCode6100");
            case "6200":
                return cacheStore.GetString("DocumoResultCode6200");
            case "6300":
                return cacheStore.GetString("DocumoResultCode6300");
            case "6400":
                return cacheStore.GetString("DocumoResultCode6400");
            case "6500":
                return cacheStore.GetString("DocumoResultCode6500");
            case "6600":
                return cacheStore.GetString("DocumoResultCode6600");
            case "6800":
                return cacheStore.GetString("DocumoResultCode6800");
            case "7000":
                return cacheStore.GetString("DocumoResultCode7000");
            case "8000":
                return cacheStore.GetString("DocumoResultCode8000");
            case "9000":
                return cacheStore.GetString("DocumoResultCode9000");
            default:
                return cacheStore.GetString("FaxFailedToSend");
        }
    }
}

export { PortfolioHelper };
